import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Education() {
    const [articles, setArticles] = useState([]);
    useEffect(() => { api.get("/education").then(r => setArticles(r.data)); }, []);

    return (
        <div className="space-y-8" data-testid="education-page">
            <div>
                <div className="label-eyebrow text-accent-red">Learn the system</div>
                <h1 className="font-display text-4xl font-black uppercase sm:text-5xl">Education</h1>
                <p className="mt-2 max-w-2xl text-sm text-muted-foreground">Original, evidence-based explanations of why this training system works. Read these before you question your programming.</p>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
                {articles.map(a => (
                    <Link key={a.slug} to={`/education/${a.slug}`} data-testid={`article-${a.slug}`} className="block-shadow tactical-card p-6">
                        <div className="label-eyebrow text-accent-red">{a.category} · {a.read_min} min</div>
                        <h3 className="mt-2 font-display text-2xl font-black uppercase">{a.title}</h3>
                        <p className="mt-2 text-sm text-muted-foreground">{a.summary}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
}
